import type { BlocoDetail } from '@/types/bloco'
import { formatBlocoDueLabel } from './blocosUtils'

export function printBlocoDetail(detail: BlocoDetail) {
  const dueLabel = formatBlocoDueLabel(detail)
  const messagesHtml = detail.messages
    .map(
      (message) => `
        <div style="margin-bottom:12px;padding:10px;border:1px solid #e5e7eb;border-radius:8px;">
          <div style="font-size:12px;color:#6b7280;margin-bottom:4px;">
            <strong>${escapeHtml(message.author.name)}</strong> · ${new Date(message.createdAt).toLocaleString('pt-BR')}
          </div>
          <div style="white-space:pre-wrap;font-size:14px;">${escapeHtml(message.body)}</div>
        </div>`,
    )
    .join('')

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${escapeHtml(detail.title)}</title>
    <style>body{font-family:system-ui,sans-serif;padding:24px;color:#111}h1{font-size:20px}h2{font-size:14px;color:#555}</style>
    </head><body>
    <h1>${escapeHtml(detail.title)}</h1>
    <h2>${escapeHtml(detail.subject)}</h2>
    ${dueLabel ? `<p><strong>Retorno:</strong> ${escapeHtml(dueLabel)}</p>` : ''}
    ${detail.body.trim() ? `<div style="margin:16px 0;white-space:pre-wrap;">${escapeHtml(detail.body)}</div>` : ''}
    <h3 style="font-size:14px;margin-top:24px;">Mensagens</h3>
    ${messagesHtml || '<p style="color:#6b7280;">Sem mensagens.</p>'}
    </body></html>`

  const win = window.open('', '_blank', 'noopener,noreferrer')
  if (!win) return
  win.document.write(html)
  win.document.close()
  win.focus()
  win.print()
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
